<!--
 * @Descripttion: 
 * @version: 
 * @Author: Raoxf
 * @Date: 2022-05-28 20:17:07
 * @LastEditors: Raoxf
 * @LastEditTime: 2023-04-08 09:34:41
-->
<template>
  <el-dialog
    title="新增/编辑商品"
    :visible.sync="visible"
    :before-close="handleClose"
    top="10px"
    width="80%"
  >
    <el-form
      ref="formName"
      :rules="newRuler"
      :model="newDate"
      :hide-required-asterisk="false"
    >
      <el-form-item
        label="商品类目"
        prop="housekeepingCategoryId"
        label-width="140px"
      >
        <el-select
          v-model="newDate.housekeepingCategoryId"
          placeholder="请选择一级类目"
          size="mini"
          @change="handleCategoryChange"
          style="width: 200px; margin-right: 10px"
        >
          <el-option
            v-for="item in categoryList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          ref="childCategorySelect"
          v-model="newDate.housekeepingChildCategoryId"
          placeholder="请选择二级类目"
          size="mini"
          :disabled="!newDate.housekeepingCategoryId"
          :key="`child-category-${newDate.housekeepingCategoryId || 'empty'}-${
            childrenList.length
          }`"
          @change="handleChildCategoryChange"
          style="width: 200px"
        >
          <el-option
            v-for="item in childrenList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品类别" prop="source" label-width="140px">
        <el-select v-model="newDate.source" placeholder="请选择" size="mini">
          <el-option
            v-for="item in sourceList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="活动截止时间"
        prop="source"
        label-width="140px"
        v-if="newDate.source == 3"
      >
        <el-date-picker
          v-model="newDate.activityTime"
          type="datetime"
          value-format="yyyy-MM-dd hh:mm:ss"
          size="mini"
          :picker-options="pickerOptions"
          placeholder="活动截止时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="商品名称" prop="name" label-width="140px">
        <el-input
          type="textarea"
          v-model="newDate.name"
          size="mini"
          style="width: 60%"
          @keydown.enter.native="textareaKeydown"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品备注" prop="name" label-width="140px">
        <el-input
          type="textarea"
          v-model="newDate.remark"
          size="mini"
          style="width: 60%"
          @keydown.enter.native="textareaKeydown"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品视频" prop="video" label-width="140px">
        <el-upload
          class="form-upload"
          ref="uploadvideo"
          action="#"
          name="videoUrl"
          accept=".mp4, .avi, .mov, .wmv, .flv"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="
            (file, fileList) => {
              handVideoFile(file, fileList);
            }
          "
        >
          <el-button slot="trigger" size="small" type="primary"
            >上传视频
          </el-button>
        </el-upload>
        <div v-if="newDate.video" style="margin-top: 10px">
          <video
            :src="formatCover(newDate.video)"
            controls
            style="max-width: 300px; max-height: 200px"
          ></video>
          <img
            @click="deleteVideo"
            src="../../../assets/delete.png"
            style="
              height: 20px;
              width: 20px;
              margin-left: 10px;
              cursor: pointer;
            "
          />
        </div>
      </el-form-item>
      <el-form-item label="商品主图" prop="cover" label-width="140px">
        <el-upload
          class="form-upload"
          ref="uploadcover"
          action="#"
          name="coverUrl"
          accept=".png, .jpg,.gif, .GIF"
          :show-file-list="false"
          :auto-upload="false"
          multiple
          :on-change="
            (file, fileList) => {
              handManyFile(file, fileList, 1);
            }
          "
        >
          <el-button slot="trigger" size="small" type="primary"
            >上传图片
          </el-button>
        </el-upload>
        <span
          v-if="newDate.cover"
          style="
            display: inline-block;
            width: 100px;
            height: 100px;
            position: relative;
          "
        >
          <img
            @click="deleteImg(1)"
            src="../../../assets/delete.png"
            style="height: 20px; width: 20px; position: absolute; right: 0"
          />
          <el-popover placement="left" title="" trigger="hover" width="200">
            <img :src="formatCover(newDate.cover)" width="100%" />
            <img
              slot="reference"
              :src="formatCover(newDate.cover)"
              :alt="formatCover(newDate.cover)"
              style="height: 80px; width: 80px; padding: 10px"
            />
          </el-popover>
        </span>
      </el-form-item>
      <el-form-item label="商品图片" prop="imgs" label-width="140px">
        <el-upload
          class="form-upload"
          ref="uploadbanner"
          action="#"
          name="bannerUrl"
          accept=".png, .jpg"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="
            (file, fileList) => {
              handManyFile(file, fileList, 2);
            }
          "
          multiple
          :disabled="newDate.banner.length >= 9"
        >
          <el-button
            slot="trigger"
            size="small"
            type="primary"
            :disabled="newDate.banner.length >= 9"
            >上传图片
          </el-button>
        </el-upload>
        <span
          v-for="(item, index) in newDate.banner"
          :key="index"
          style="
            display: inline-block;
            width: 100px;
            height: 100px;
            position: relative;
          "
        >
          <img
            @click="deleteImg(2, index)"
            src="../../../assets/delete.png"
            style="height: 20px; width: 20px; position: absolute; right: 0"
          />
          <el-popover placement="left" title="" trigger="hover" width="200">
            <img :src="host + item" width="100%" />
            <img
              slot="reference"
              :src="host + item"
              :alt="host + item"
              style="height: 80px; width: 80px; padding: 10px"
            />
          </el-popover>
        </span>
      </el-form-item>
      <el-form-item label="商品详情" prop="itemDetail" label-width="140px">
        <el-upload
          class="avatar-uploader"
          action="#"
          name="img"
          accept=".png, .jpg"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handManyFileDetail"
          :before-upload="beforeUpload"
          multiple
        >
        </el-upload>
        <!--富文本编辑器组件-->
        <el-row v-loading="quillUpdateImg">
          <quill-editor
            class="quills"
            v-model="newDate.content"
            ref="myQuillEditor"
            :options="editorOption"
            style="width: 100%; min-height: 50px; margin-bottom: 10px"
          >
          </quill-editor>
        </el-row>
      </el-form-item>
      <el-form-item label="销售价格" prop="price" label-width="140px">
        <el-input
          clearable
          class="inputNo"
          placeholder="请输入售价"
          min="0"
          size="mini"
          @mousewheel.native.prevent
          v-model="newDate.price"
          @input="clearNoNum(newDate.price, 'price')"
        ></el-input>
        <el-input
          clearable
          class="inputNo"
          placeholder="请输入原价"
          min="0"
          size="mini"
          @mousewheel.native.prevent
          v-model="newDate.originalPrice"
          @input="clearNoNumFill(newDate.originalPrice, 'originalPrice')"
        ></el-input>
      </el-form-item>
      <el-form-item label="销售类型(时长/面积)" prop="productType">
        <el-radio-group v-model="newDate.productType" size="small">
          <el-radio label="1">次数</el-radio>
          <el-radio label="2">面积</el-radio>
          <el-radio label="3">时长</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item
        label="销售单位"
        label-width="140px"
        prop="type"
        v-if="newDate.productType == 1"
      >
        <el-radio-group v-model="newDate.type" size="small">
          <el-radio label="1">时</el-radio>
          <el-radio label="2">天</el-radio>
          <el-radio label="3">月</el-radio>
          <el-radio label="4">年</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item
        label="可服务次数"
        label-width="140px"
        prop="appointmentsNum"
      >
        <el-input-number
          v-model="newDate.appointmentsNum"
          size="mini"
          :min="1"
          label="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="单次服务时长"
        label-width="140px"
        prop="duration"
        v-if="newDate.productType == 2"
      >
        <el-input-number
          v-model="newDate.duration"
          size="mini"
          :min="1"
          label="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="配置属性" label-width="140px" prop="type">
        <el-table :data="skuList" border stripe style="width: 100%">
          <el-table-column prop="categoryName" label="属性">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.categoryName"
                placeholder="请输入属性名称"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="售价">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.price"
                placeholder="售价/单价填写一个"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="serviceDuration"
            v-if="newDate.productType != 2"
            label="单次服务时长"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.serviceDuration"
                placeholder="单次服务时长"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="perPrice"
            v-else
            label="单价"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.perPrice"
                placeholder="单价"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="originalPrice" label="原价">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.originalPrice"
                placeholder="请输入原价"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="perPrice" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="onAddSku"
                v-if="scope.$index == skuList.length - 1"
                >新增</el-button
              >
              <el-button type="text" @click="onDelSku(scope.row, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="配置销量" label-width="140px">
        <el-input
          v-model="newDate.salesVolume"
          size="mini"
          style="width: 60%"
        ></el-input
        >件
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose()">取 消 </el-button>
      <el-button type="primary" size="small" @click="onSubmit(0)"
        >保 存
      </el-button>
      <el-button
        type="primary"
        v-if="editFlag && (newDate.isPublic == 0 || !newDate.isPublic)"
        size="small"
        @click="onSubmit(1)"
        >保存并上架
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
// import vuedraggable from "vuedraggable";
import { HandleDirective } from "vue-slicksort";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"],
  ["clean"], // remove formatting button
];

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      // 新增数据
      newDate: {
        productType: "1",
        banner: [], //商品图片列表
        cover: "", // 商品主图
        video: "", // 商品视频
        name: "", //商品标题
        content: "", //商品富文本详情
        originalPrice: "", // 原价
        price: "", //现价
        type: "1",
        activityTime: "",
        duration: 1,
        appointmentsNum: 1,
        housekeepingCategoryId: "", // 一级类目ID
        housekeepingChildCategoryId: "", // 二级类目ID
      },
      copyFlag: this.$route.query.copyFlag || 1, //是否打开复制商品  1否  2是
      value: {},
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      editorOption: {
        // 富文本编辑器配置
        placeholder: "",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      newRuler: {
        housekeepingCategoryId: [
          { required: true, message: "请选择一级类目", trigger: "change" },
        ],
        housekeepingChildCategoryId: [
          { required: true, message: "请选择二级类目", trigger: "change" },
        ],
        source: [
          { required: true, message: "请选择商品类目", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        price: [{ required: true, message: "请输入商品售价", trigger: "blur" }],
        productType: [
          { required: true, message: "请选择商品销售类型", trigger: "blur" },
        ],
        duration: [
          { required: true, message: "请输入单次服务时长", trigger: "blur" },
        ],
        appointmentsNum: [
          { required: true, message: "请输入可服务次数", trigger: "blur" },
        ],
      },
      sourceList: [
        { label: "无", value: 0 },
        // { label: "家庭保洁", value: 1 },
        // { label: "企业保洁", value: 2 },
        { label: "首页限时秒杀", value: 3 },
        // { label: "GIF活动商品", value: 4 },
        { label: "推荐商品", value: 5 },
      ],
      editFlag: false,
      categoryList: [], // 一级类目列表
      childrenList: [], // 二级类目列表
      skuList: [
        {
          categoryName: "",
          price: "",
          originalPrice: "",
          perPrice: "",
          serviceDuration: ''
        },
      ],
    };
  },
  created() {
    this.getCategoryData();
  },
  methods: {
    // 获取类目数据
    async getCategoryData() {
      try {
        const data = await this.$get("/housekeepingCategory/list");
        this.categoryList = data.map((item) => ({
          value: item.id,
          label: item.name,
          children: item.childrenList || [],
        }));
      } catch (error) {
        this.$message.error("获取类目数据失败");
      }
    },
    // 一级类目变化
    handleCategoryChange(value) {
      this.$set(this.newDate, "housekeepingChildCategoryId", "");
      const selectedCategory = this.categoryList.find(
        (item) => item.value === value
      );
      this.childrenList = selectedCategory
        ? selectedCategory.children.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        : [];
      // 确保 DOM 更新
      this.$nextTick(() => {
        // 强制更新二级类目选择框
        if (this.$refs.formName) {
          this.$refs.formName.clearValidate("housekeepingChildCategoryId");
        }
      });
    },
    // 二级类目变化
    handleChildCategoryChange(value) {
      // v-model 已经处理了值的更新，这里只需要确保视图更新
      // 强制更新组件以确保 DOM 正确显示
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    formatCover(cover) {
      if (cover.indexOf("http") > -1) {
        return cover;
      }
      return this.host + cover;
    },
    // 编辑商品
    async getEditData(info) {
      let data = JSON.parse(JSON.stringify(info));
      data.banner = data.banner ? data.banner.split(",") : [];
      data.banner = data.banner.map((item) => {
        item = item.replaceAll(this.host, "");
        return item;
      });
      data.cover = data.cover ? data.cover.replaceAll(this.host, "") : "";
      data.video = data.video ? data.video.replaceAll(this.host, "") : "";
      data.type = String(data.type);
      data.productType = String(data.productType);

      // 处理类目数据回显
      if (data.housekeepingCategoryId) {
        this.handleCategoryChange(data.housekeepingCategoryId);
      }

      let list = await this.$get("/product/categoryList", {
        productId: data.productId,
      });
      this.skuList =
        list.length > 0
          ? list
          : [
              {
                categoryName: "",
                price: "",
                originalPrice: "",
                perPrice: "",
                serviceDuration: ''
              },
            ];
      this.editFlag = true;
      this.newDate = data;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.onClose();
        })
        .catch((_) => {});
    },
    // 获取编辑商品详情
    async getProductDetail(productId) {
      let data = await this.$get("/product/getDetails", {
        productId,
      });
      data.banner = data.banner
        ? data.banner.replaceAll(this.host, "").split(",")
        : "";
      data.cover = data.cover ? data.cover.replaceAll(this.host, "") : "";
      data.video = data.video ? data.video.replaceAll(this.host, "") : "";
      data.type = String(data.type);

      // 处理类目数据回显
      if (data.housekeepingCategoryId) {
        this.handleCategoryChange(data.housekeepingCategoryId);
      }

      this.newDate = data;
    },
    // 上传商品封面
    async handManyFile(file, fileList, type) {
      var param = new FormData();
      param.append("file", file.raw);
      let data = await this.$upload("/File/upload", param);
      if (type == 1) {
        // 商品封面图
        this.newDate.cover = data;
      } else {
        this.newDate.banner.push(data);
      }
    },
    //上传商品详情图
    async handManyFileDetail(file, fileList) {
      var param = new FormData();
      param.append("file", file.raw);
      let data = await this.$upload("/File/upload", param);
      this.uploadSuccess(data);
    },
    // 上传商品视频
    async handVideoFile(file, fileList) {
      var param = new FormData();
      param.append("file", file.raw);
      let data = await this.$upload("/File/upload", param);
      this.newDate.video = data;
    },
    deleteImg(type, index) {
      this.$confirm("确认删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (type == 1) {
            // 删除封面
            this.newDate.cover = "";
          } else {
            // 删除海报
            this.newDate.banner.splice(index, 1);
          }

          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 删除视频
    deleteVideo() {
      this.$confirm("确认删除该视频, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.newDate.video = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //确认保存
    async onSubmit(type) {
      this.$refs.formName.validate(async (valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.newDate));
          let errList = this.skuList.filter(
            (list) => list.price == "" && list.perPrice == ""
          );
          if (errList.length > 0) {
            this.$message.error("商品属性的单价或原价未填写，请检查！");
            return;
          }
          params.params = JSON.stringify(this.skuList);
          if (params.banner.length > 0) {
            params.banner = params.banner.join(",");
          }
          params.isPublic = type;
          params.content = params.content.replaceAll(this.host, "");
          params.video = params.video
            ? params.video.replaceAll(this.host, "")
            : "";
          let productId = "";
          if (this.editFlag) {
            productId = params.productId;
            // 编辑
            await this.$post("/product/edit", params);
          } else {
            // 新增
            productId = await this.$post("/product/enter", params);
          }
          this.$Message.info(`${this.editFlag ? "编辑成功" : "新增成功"}`);
          this.resetForm();
          this.$emit("refresh");
          this.$emit("close");
        }
      });
    },
    resetForm() {
      this.$refs.formName.resetFields();
    },
    // 富文本图片上传前
    beforeUpload() {
      // 显示loading动画
      this.quillUpdateImg = true;
    },
    uploadSuccess(fileUrl) {
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 获取光标所在位置
      let length = quill.selection.savedRange.index;
      // 插入图片  res.info为服务器返回的图片地址
      quill.insertEmbed(length, "image", this.host + fileUrl);
      // 调整光标到最后
      quill.setSelection(length + 1);
      // loading动画消失
      this.quillUpdateImg = false;
    },
    textareaKeydown() {
      let e = window.event || arguments[0];
      if (e.key == "Enter" || e.code == "Enter" || e.keyCode == 13) {
        e.returnValue = false;
        return false;
      }
    },
    //列表金额规格限制
    clearNoNum(a, name) {
      a = a.replace(/[^\d.]/g, "");
      a = a.replace(/\.{2,}/g, ".");
      a = a.replace(/^\./g, "");
      a = a.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      if (a.indexOf(".") == -1 && a) {
        a = Number(a);
        a = JSON.stringify(a);
      }
      this.newDate[name] = a;
    },
    clearNoNumFill(a, name) {
      a = a.replace(/[^\d.]/g, "");
      a = a.replace(/\.{2,}/g, ".");
      a = a.replace(/^\./g, "");
      a = a.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      if (a.indexOf(".") == -1 && a) {
        a = Number(a);
        a = JSON.stringify(a);
      }
      this.newDate[name] = a;
    },
    onClose() {
      this.$emit("close");
    },
    // 添加销售属性
    onAddSku() {
      this.skuList.push({
        categoryName: "",
        price: "",
        originalPrice: "",
        perPrice: "",
        serviceDuration: ''
      });
      this.$forceUpdate();
    },
    onDelSku(item, index) {
      if (this.skuList.length == 1 && this.newDate.productType != 1) {
        this.$message.warning("最后一条不可删除");
        return;
      }
      this.delSku(item, index)
     
    },
    async delSku(item, index) {
      if (item.id) {
        await this.$get("/product/deleteProductCategoryById", {
          id: item.id
        });
      }
      this.skuList.splice(index, 1);
      this.$forceUpdate();
    }
  },
  components: {
    quillEditor,
  },
  directives: { handle: HandleDirective },
};
</script>

<style lang="stylus" scoped>
@import './../../../styl/variables.styl'
@import './../../../styl/common.styl'
.header {
  margin-left: 20px;
}

input[type='number'] {
  -moz-appearance: textfield;
}

el-input {

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.inputNo {

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }
}
.el-table .cell {
  display: flex !important;
}
.picker{
  margin-left: 10px;
}
.filter-search
  display flex
  flex-wrap wrap
.el-date-editor
  max-width 360px
  margin-right 10px
  margin-bottom 10px
.el-input
  max-width 200px
  margin-right 10px
  margin-bottom 10px
.option-button
  position relative
  padding-right 50px
.edit-btn
  position absolute
  right 4px
.form-upload-excel
  display inline-block
  margin-left 10px
.table-container
  margin-top 20px
.el-pagination
  margin-top 20px
.el-dialog__body
  .el-form
    height 470px
    padding 10px
    overflow-y scroll
  .el-input-number
    margin-left 10px
  .preview
    display flex
    justify-content center
    align-items center
    padding 10px
    margin-top 6px
    border 1px dashed #999
    border-radius 6px
  img
    cursor pointer
    max-width 300px
.dialog-img
  display flex
  justify-content center
  align-items center
  padding 10px
  img
    max-width 600px
.el-cascader
  width 300px
.littleMarginLeft
  margin-left: 5px;

.quills>>>.ql-container {
  min-height: 400px;
}

.gys {
  display: flex;
  flex-flow: column;
  align-items: center;
  line-height: normal;
  height: 84px;
}

.gys>>>.el-select {
  width: 140px;
  height: 40px;
}


.ifred {
  border: 2px solid red;
}

.dialog-footer {
  text-align: center;
}

.imgHush {
  .imgHushdiv {
    display: flex;
    flex-flow: column;
    align-items: center;
  }
}

.imgHush>>>.el-checkbox__input {
  float: right;
}

.table-container /deep/ input::-webkit-outer-spin-button,
.table-container /deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.table-container /deep/ input[type="number"] {
  -moz-appearance: textfield;
}
.yongjin /deep/ .el-input-group__append {
  width: 80px;
}
</style>
